import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-restaurant',
  templateUrl: './restaurant.component.html',
  styleUrls: ['./restaurant.component.scss'],
})
export class RestaurantComponent {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  openFullscreen(event: MouseEvent) {
    if (!isPlatformBrowser(this.platformId)) return;
    const clickedImg = event.target as HTMLImageElement;
    const overlay = document.querySelector('.fullscreen-overlay') as HTMLElement;
    const fullscreenImg = overlay.querySelector('img') as HTMLImageElement;
    fullscreenImg.src = clickedImg.src;
    overlay.classList.add('active');
  }

  closeFullscreen() {
    if (!isPlatformBrowser(this.platformId)) return;
    const overlay = document.querySelector('.fullscreen-overlay') as HTMLElement;
    overlay.classList.remove('active');
  }
}
